import React, { useContext, useEffect } from 'react'
import { authContext } from './configurations/auth/authContext';
import RouterContainer from './components/RouterContainer';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import SideBar from './components/base/SideBar';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './configurations/GlobalConfig';
import { AuthProvider } from './configurations/auth/publicUsers/useAuth';

export default function Main() {
    const [isLogin, setIsLogin] = useContext(authContext);

    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AuthProvider>
                <HashRouter>
                    {isLogin && <SideBar />}

                    <RouterContainer />
                </HashRouter>
            </AuthProvider>
        </GoogleOAuthProvider>
    )
}
